module.exports = __webpack_public_path__ + "img/GPTSoul.e8a7fb51.svg";